import { CardinalOrientation } from '@pmi/dsm-react';
import { CoachMarkStep } from '@pmi/dsm-react/dist/components/coachmark/types';

export const dashboardCoachMarkSteps: CoachMarkStep[] = [
  {
    orientationPreferences: [CardinalOrientation.NORTH],
    selector: 'h1.admin-page-header-title::after',
    title: 'Home Overview',
    description:
      'Use this view as a general overview to see your agreements, products, and metrics.',
  },
  {
    orientationPreferences: [CardinalOrientation.NORTH],
    selector: '.dashboard-card-block',
    title: 'Account Data',
    description:
      "These five cards give a snapshot of your account's top-level data across all agreements.",
  },
  {
    orientationPreferences: [CardinalOrientation.NORTH],
    selector: '.dashboard-alc table tbody tr:first-child',
    title: 'Agreement Details',
    description:
      'Your agreement information is listed here, including your products and how much available quantity is remaining to enroll in. You can click the agreement title to open.',
  },
  {
    orientationPreferences: [CardinalOrientation.WESTNORTH],
    selector: '.dashboard-alc table tbody tr:first-child td:last-child button',
    title: 'Agreement Options',
    description:
      'You can also click on the ellipses next to the agreement to see available options.',
  },
];
export const agreementDetailsCoachMarkSteps: CoachMarkStep[] = [
  {
    orientationPreferences: [CardinalOrientation.NORTH],
    selector: 'h1.admin-page-header-title::after',
    title: 'Agreement Overview',
    description:
      'Use this view as a general overview of your agreement and its products and metrics.',
  },
  {
    orientationPreferences: [CardinalOrientation.SOUTH],
    selector: '.homepage-agreement-name-block',
    title: 'Agreement',
    description:
      'Your agreement contains your product(s) that can be assigned to your Users when invited. You can add/edit a name if desired.',
  },
  {
    orientationPreferences: [CardinalOrientation.SOUTHWEST],
    selector: '.agreement-breadcrumbs',
    title: 'Agreement Selection',
    description:
      'You can go back to your agreement list by selecting the All Agreements breadcrumb link.',
  },
  {
    orientationPreferences: [CardinalOrientation.NORTHWEST],
    selector: '.homepage-deal-details-block .details-cards-block',
    title: 'Agreement Data',
    description:
      'Your Agreement information is listed here, which includes real-time data for the Agreement.',
  },
  {
    orientationPreferences: [CardinalOrientation.NORTHWEST],
    selector: '.deal-products-table-container table tbody tr:first-child',
    title: 'Product Details',
    description:
      'Your product information is listed here, including how much available quantity is remaining to enroll in. Available quantity reduces after product enrollment.',
  },
  {
    orientationPreferences: [CardinalOrientation.WEST],
    selector: '.dashboard-add-people',
    title: 'Invite Someone!',
    description:
      'To add user(s) to a specific agreement you can add them here. If you add them by email address they will receive an invitation email.',
  },
];

export const peopleUserTabCoachMarkSteps: CoachMarkStep[] = [
  {
    selector: 'h1.admin-page-header-title::after',
    orientationPreferences: [CardinalOrientation.CENTER],
    title: 'People Overview',
    description:
      'Use this view to track, search, edit, and add people to your platform.',
  },
  {
    selector: '.people-users_search-filter',
    orientationPreferences: [CardinalOrientation.EAST],
    title: 'Search and Filter',
    description:
      'You can search for a specific user or use filters to find groups of like users.',
  },
  {
    selector: 'table tbody tr:first-child td:nth-child(2)',
    orientationPreferences: [CardinalOrientation.EAST],
    title: 'Person Details',
    description:
      "You can select a user's name to view more information and edit them, or you can use checkboxes to select multiple users to bulk edit.",
  },
  {
    selector: '.people-users_download_csv-btn',
    orientationPreferences: [CardinalOrientation.WEST],
    title: 'Download .csv',
    description:
      'You can extract user information that is displayed in the table for your records.',
  },
  {
    selector: '.people-users_add_people-btn',
    orientationPreferences: [CardinalOrientation.WEST],
    title: 'Invite Someone!',
    description:
      'You can add additional people and grant them access to products here. If you add them by email address they will receive an invitation email.',
  },
];

export const peopleAdminTabCoachMarkSteps: CoachMarkStep[] = [
  {
    selector: 'h1.admin-page-header-title::after',
    orientationPreferences: [CardinalOrientation.EAST],
    title: 'People Overview',
    description:
      'Use this view to track, search, edit, and add people to your platform.',
  },
  {
    selector: '.people-admins_search-filter',
    orientationPreferences: [CardinalOrientation.EAST],
    title: 'Search and Filter',
    description:
      'You can search for a specific user or use filters to find groups of like users.',
  },
  {
    selector: 'table tbody tr:first-child',
    orientationPreferences: [CardinalOrientation.NORTHWEST],
    title: "Administrator's Details",
    description:
      "You can view your administrator's information, or use the actions on the right to edit or remove them.",
  },
  {
    selector: '.people-admins_invite_admin-btn',
    orientationPreferences: [CardinalOrientation.WEST],
    title: 'Add Admins',
    description: 'You can invite new administrators by clicking this button.',
  },
];

export const reportOverviewCoachMarkSteps: CoachMarkStep[] = [
  {
    selector: 'h1.admin-page-header-title::after',
    orientationPreferences: [CardinalOrientation.EAST],
    title: 'Reports Overview',
    description:
      "This page collects your user's enrollment data including the financials across products.",
  },
  {
    selector: '.deal-tabs',
    orientationPreferences: [CardinalOrientation.SOUTHWEST],
    title: 'Agreement selection',
    description:
      'You can filter your reports by an agreement, or select "All Agreements" to view all data.',
  },
  {
    selector: '.report_overview-date_tabs [role="tablist"]',
    orientationPreferences: [CardinalOrientation.EAST],
    title: 'Reports Selection',
    description:
      'Data can be filtered by dates by either all enrollments, enrollments occurring this month, enrollments occurring last month, or a custom range of your choosing.',
  },
  {
    selector: '.report_overview-download_csv-btn',
    orientationPreferences: [CardinalOrientation.WEST],
    title: 'Download .csv',
    description:
      "You can also download a .csv your account's enrollment data at any time for easier use.",
  },
  {
    selector: 'table tbody tr:first-child td:first-child',
    orientationPreferences: [CardinalOrientation.EAST],
    title: 'Dive into a specific product',
    description:
      'Click on the product in the table to see a detailed breakdown (must close tour first).',
  },
];

export const reportDetailsCoachMarkSteps: CoachMarkStep[] = [
  {
    selector: 'h1.admin-page-header-title::after',
    orientationPreferences: [CardinalOrientation.EAST],
    title: 'Product Reporting Overview',
    description:
      'Use this view to see more details about a particular product, including the users who have enrolled and their status.',
  },
  {
    selector: '.report_details-date_tabs [role="tablist"]',
    orientationPreferences: [CardinalOrientation.EAST],
    title: 'Product Reporting',
    description:
      'Data can be filtered by dates by either all enrollments, enrollments occurring this month, enrollments occurring last month, or a custom range of your choosing.',
  },
  {
    selector:
      '.report_details-registered_users-table table tbody tr:first-child',
    orientationPreferences: [CardinalOrientation.NORTHWEST],
    title: 'People Reporting',
    description: 'Enrollment data can be found in this table.',
  },
];

export const productGroupCoachMarkSteps: CoachMarkStep[] = [
  {
    selector: 'h1.admin-page-header-title::after',
    orientationPreferences: [CardinalOrientation.EAST],
    title: 'Product Groups Overview',
    description:
      'Product Groups are used to assign products to users. You can use this page to track/manage your existing groups or add more.',
  },
  {
    selector: '.product_group-all_products-card',
    orientationPreferences: [CardinalOrientation.NORTHWEST],
    title: 'All Products',
    description:
      'Your "All Products" group exists by default and contains all of the products on your agreement.',
  },
  {
    selector: '.product_group-add-people_domain-btn',
    orientationPreferences: [CardinalOrientation.NORTHEAST],
    title: 'Add People to All Products',
    description:
      'You can add people to your groups. Also, when you make a custom group, you can update the products within.',
  },
  {
    selector: '.product_group-create-new-product_group-btn',
    orientationPreferences: [CardinalOrientation.WEST],
    title: 'Creating a New Product Group',
    description:
      'Custom groups that you create will appear below, and can be modified by selecting the options to either change the name, update the products, or assign/unassign users.',
  },
];

export function updateStepSelector(
  steps: CoachMarkStep[],
  selector: string,
  replaceTo: string,
) {
  const items = [...steps];
  if (!document.querySelector(selector)) {
    const index = steps.findIndex((s) => s.selector === selector);
    const step = index >= 0 ? { ...steps[index] } : null;
    if (step) {
      step.selector = replaceTo;
      items[index] = step;
    }
  }
  return items;
}
